import { FormSection } from './FormSection';
import { ImageUploader } from '../ImageUploader';
import { useTranslation } from 'react-i18next';

interface MenuItemImageProps {
  initialImage?: string | null;
  onImageUploaded: (imageUrl: string | null) => void;
}

export function MenuItemImage({
  initialImage,
  onImageUploaded,
}: MenuItemImageProps) {
  const { t } = useTranslation();

  return (
    <FormSection title='image'>
      <ImageUploader
        initialImage={initialImage}
        onImageUploaded={onImageUploaded}
      />
      <p className='text-xs text-muted-foreground mt-1'>
        {t('uploadImageInfo')}
      </p>
    </FormSection>
  );
}
